import Fields from "./BatterCalculatorFields";
import Result from "./BatterCalculatorResult";
import Description from "./BatterCalculatorDescription";
import calculate from "./calculate";
import Custom from "../customCalculator/CustomCalculatorFormContainer";

const BatterCalculator = { Description, Fields, Result, Custom, calculate };

export default BatterCalculator;
